import { atom } from 'jotai';
import type { LiveFeed } from '@localagent/sdk';
import { configureAtomDevtools } from '../utils/tracking';

/** Shared LiveFeed handle for badge, toasts, and the feed view (feed ADR-008). */
export const liveFeedHandleAtom = configureAtomDevtools(
  atom<LiveFeed | null>(null),
  'sdk/liveFeedHandle',
);

export const liveFeedUnseenCountAtom = configureAtomDevtools(atom(0), 'sdk/liveFeedUnseen');
